const actionTypes = {
    GET_RECON_FILTER_SUCCESS: 'GET_RECON_FILTER_SUCCESS',
};

export default actionTypes;